<template>
<div class="is-flex align-start">
  <risk-tag 
    v-if="unresolvedFindings" 
    :level="riskLevel"
  />
  <span v-else class="tag is-medium is-rounded is-success">
    <icon icon="check-circle" type="far"/>
    <span>Compliant</span>
  </span>
</div>  
</template>
<script>
export default {
  
  props: {
    unresolvedFindings: {
      type: Number,
      default: 0
    },
    riskLevel: {
      type: String,
    }
  }

}
</script>